import React from "react";
import Lottie from "lottie-react";
import animData from "constants/lottiesFiles/waiting.json";

const options = {
  loop: true,
  autoplay: true,
  animationData: animData,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice"
  }
};

function WaitingAnimation() {
  return (
    <div className="d-flex flex-column w-100 text-center">
      <Lottie
        animationData={animData}
        style={{ width: "100%", height: 100 }}
        autoPlay
        loop
        options={options}
        className="mx-auto"
      />
    </div>
  );
}

export default WaitingAnimation;
